<template>
  <div class="deposit-promotions-banner" :class="bannerLevelClass" v-if="items.length">
    <div class="deposit-promotions-banner__header" v-if="showHeader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <rect width="18" height="18" rx="9" fill="currentColor" />
        <path
          d="M11.8356 6.14931C11.6699 5.54157 10.8677 4.32611 8.98479 4.32611C8.07871 4.30401 6.26656 4.65746 6.16711 6.54691C6.07289 8.33702 8.18921 8.76808 8.98479 9.06642C9.93507 9.24318 11.8356 9.97459 11.8356 11.4862C11.8356 13.3757 9.48203 13.7735 8.98479 13.7735C8.48755 13.7735 6.46546 13.6077 6.16711 11.9834M8.98479 3L8.98478 15"
          stroke="white"
          stroke-linecap="round"
        />
      </svg>
      <span>Available Promotions</span>
    </div>
    <div
      class="deposit-promotions-banner__item"
      :class="itemClass(item)"
      v-for="item in items"
      :key="item.key"
    >
      <svg
        v-if="showHeader"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 19 19"
        fill="none"
      >
        <path
          d="M13.875 5.625L8.625 12.75L4.875 9.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.375 18C14.1385 18 18 14.1385 18 9.375C18 4.61154 14.1385 0.75 9.375 0.75C4.61154 0.75 0.75 4.61154 0.75 9.375C0.75 14.1385 4.61154 18 9.375 18Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <rect width="18" height="18" rx="9" fill="currentColor" />
        <path
          d="M11.8356 6.14931C11.6699 5.54157 10.8677 4.32611 8.98479 4.32611C8.07871 4.30401 6.26656 4.65746 6.16711 6.54691C6.07289 8.33702 8.18921 8.76808 8.98479 9.06642C9.93507 9.24318 11.8356 9.97459 11.8356 11.4862C11.8356 13.3757 9.48203 13.7735 8.98479 13.7735C8.48755 13.7735 6.46546 13.6077 6.16711 11.9834M8.98479 3L8.98478 15"
          stroke="white"
          stroke-linecap="round"
        />
      </svg>
      <span v-html="item.text"></span>
    </div>
  </div>
</template>

<script src="./deposit-promotions-banner.js"></script>
<style src="./deposit-promotions-banner.scss" lang="scss"></style>
